<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent
      @row-click="selectCurrentRow">
      <el-form-item label="">
        <el-input v-model="filters.key" placeholder="Please enter"></el-input>
      </el-form-item>

      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button :type="item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
            ? 'danger'
            : 'primary'
          " @click="callFunc(item)">
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <!-- <el-button type="primary" v-if="PL_IF" @click="batchPass" :disabled="this.sels.length===0">批量审批</el-button> -->
    <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%">
      <el-table-column prop="Name" label="考试名称" width sortable></el-table-column>
      <el-table-column prop="Subject" label="课程名称" width sortable></el-table-column>
      <el-table-column prop="ExamType" label="考试类型" width sortable></el-table-column>
      <el-table-column prop="StareTime" label="考试开始时间" :formatter="formatDateTime" width sortable></el-table-column>
      <!-- <el-table-column
        prop="EndTime"
        label="考试结束时间"
        :formatter="formatDateTime"
        width="120"
        sortable
      ></el-table-column> -->
      <!-- <el-table-column
        prop="Duration"
        label="考试时长（分钟）"
        width
        sortable
      ></el-table-column> -->
      <el-table-column prop="PassScore" label="及格分数" width sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建日期" :formatter="formatDateTime" width sortable></el-table-column>
      <el-table-column prop="Status" label="状态" :formatter="formatStatus" width sortable></el-table-column>

      <el-table-column label="操作" width="300">
        <template scope="scope">
          <el-link type="primary" @click="handleOpen(scope.row.Id)">
            详情
          </el-link> |
          <el-link type="primary" @click="handleEdit(scope.row.Id)">
            编辑
          </el-link> |
          <el-link v-if="!scope.row.IsImportTopic" type="primary">
            <el-upload ref="upload" action="/api/WebExamination/TopicImportExcelData" :data="{
              Id: scope.row.Id
            }" :headers="token" :show-file-list="false" :on-success="handleSuccess"
              :before-upload="handlebefore" :on-error="handonerror" :file-list="fileList">
              上传题目
            </el-upload>
          </el-link>
          <el-link v-if="scope.row.IsImportTopic" type="primary" @click="handleClearTipic(scope.row.Id, 1)">
            清除题目
          </el-link>
          <span v-if="scope.row.IsImportTopic"> | </span>
          <el-link v-if="scope.row.IsImportTopic" type="primary" @click="handleErrorTipicOpen(scope.row.Id)">
            错题分析
          </el-link>
          <span v-if="scope.row.IsImportTopic"> | </span>
          <el-link v-if="scope.row.IsImportTopic" type="primary" @click="handleMemberExamOpen(scope.row.Id)">
            考试名单
          </el-link>
          <span v-if="scope.row.IsImportTopic"> | </span>
          <el-link v-if="scope.row.IsImportTopic" type="primary" @click="ExportMemberExamList(scope.row.Id)">
            导出考试名单
          </el-link>
          <!-- <span v-if="scope.row.ExamType=='线下考试'?true:false"> | </span> 
          <el-link  v-if="scope.row.ExamType=='线下考试'?true:false"
            type="primary"
            @click="handleDetailOpen(scope.row.Id)"
          >
            查看签到码
          </el-link>  -->



        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right"></el-pagination>
    </el-col>

    <el-dialog :title="dialog_title" :visible.sync="editFormVisible" v-model="editFormVisible"
      :before-close="editForm_close" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="考试名称" prop="Name">
              <el-input :disabled="DETAIS_IF" v-model="editForm.Name" auto-complete="off" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书" prop="CertificateId">
              <el-select :disabled="DETAIS_IF" v-model="editForm.CertificateId" filterable placeholder="请选择"
                :filter-method="CertificateId_change" style="width: 100%">
                <el-option v-for="item in Certificate_List" :key="item.Value" :label="item.Value"
                  :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="课程" prop="CurriculumId">
              <el-select :disabled="DETAIS_IF" v-model="editForm.CurriculumId" filterable placeholder="请选择"
                :filter-method="CurriculumId_change" @change="CurriculumId_change_upt_ExamType" style="width: 100%">
                <el-option v-for="item in Curriculum_ist" :key="item.Value" :label="item.Value"
                  :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试类型" prop="ExamType">
              <el-select v-model="editForm.ExamType" :disabled="DETAIS_IF" placeholder="请选择" style="width: 100%">
                <el-option label="线上考试" value="线上考试"></el-option>
                <el-option label="线下考试" value="线下考试"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="StareTime">
              <el-date-picker :disabled="DETAIS_IF" v-model="editForm.StareTime" type="date" placeholder="请选择"
                format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select v-model="editForm.Status" :disabled="DETAIS_IF" placeholder="请选择" style="width: 100%">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="结束时间" prop="EndTime">
              <el-date-picker
                :disabled="DETAIS_IF"
                v-model="editForm.EndTime"
                type="date"
                placeholder="请选择"
                format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select
                v-model="editForm.Status"
                :disabled="DETAIS_IF"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试时长（分钟）" prop="Duration">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Duration"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="及格分数" prop="PassScore">
              <el-input :disabled="DETAIS_IF" v-model="editForm.PassScore" auto-complete="off"
                placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="Reamrk">
              <el-input :disabled="DETAIS_IF" v-model="editForm.Reamrk" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="标签" prop="Tids">
              <el-select multiple v-model="editForm.Tids" placeholder="请选择标签">
                <el-option :key="0" :label="'没有选择标签'" :value="0"></el-option>
                <el-option v-for="item in tags" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_close">取消</el-button>
        <el-button v-if="!DETAIS_IF" type="primary" @click.native="editSubmit('editForm')" :loading="editLoading">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="detailFormVisible" v-model="detailFormVisible"
      :before-close="detailForm_close" :close-on-click-modal="false" width="500px">
      <el-form :model="detailForm" label-width="180px" ref="detailForm">
        <el-row style="text-align: center;">
          <el-col :span="24">
            <el-image style="width: 200px; height: 200px;" :src="QrCode_imageUrl">
            </el-image>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="detailForm_close">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="ErrorTipicVisible" v-model="ErrorTipicVisible"
      :before-close="ErrorTipic_close" :close-on-click-modal="false">
      <div v-for="item in ErrorTipicDataList" v-bind:key="item.id" :label=item.TopicName>
        {{ item.TopicName }} <br />
        <span>正确率：</span>
        <span style="color:red">{{ item.IsRightAnswerPercent }}</span>
        <br />
        <span>正确答案：</span>
        <span style="color:red">{{ item.IsRightAnswer }}</span>
        <el-table :data="item.AnswerList" highlight-current-row v-loading="listLoading" style="width: 100%">
          <el-table-column prop="Option" label="选项" width>
            <!-- <template scope="scope"> <span>
              {{scope.row.Option}}
            </span></template> -->
          </el-table-column>
          <el-table-column prop="MemberNum" label="小计" width>
          </el-table-column>
          <el-table-column prop="MemberNumPercent" label="比例" width>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="ErrorTipic_close">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="MemberExamVisible" v-model="MemberExamVisible"
      :before-close="MemberExam_close" :close-on-click-modal="false" width="60%">
      <el-form :inline="true" :model="MemberExamFilters" @submit.native.prevent>
        <el-form-item label="客户名称">
          <el-input v-model="MemberExamFilters.AccountShortName" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input v-model="MemberExamFilters.StoreName" placeholder="请输入门店名称"></el-input>
        </el-form-item>
        <el-form-item label="学员名称">
          <el-input v-model="MemberExamFilters.MemberName" placeholder="请输入学员名称"></el-input>
        </el-form-item>
        <button @click="MemberExam_GetMemberExamList(0)" type="button"
          class="el-button el-button--primary el-button--medium"><span>
            查询
          </span>
        </button>
      </el-form>
      <el-table :data="MemberExamDataList" highlight-current-row v-loading="listLoading" style="width: 100%">
        <el-table-column prop="ExamName" label="考试名称" width sortable>
        </el-table-column>
        <el-table-column prop="Subject" label="课程名称" width sortable>
        </el-table-column>
        <el-table-column prop="ExamType" label="考试类型" width sortable>
        </el-table-column>
        <el-table-column prop="PassScore" label="及格分数" width sortable>
        </el-table-column>
        <el-table-column prop="AccountShortName" label="客户名称" width sortable>
        </el-table-column>
        <el-table-column prop="StoreName" label="门店名称" width sortable>
        </el-table-column>
        <el-table-column prop="MemberName" label="学员名称" width sortable>
        </el-table-column>
        <el-table-column prop="Point" label="得分" width sortable>
        </el-table-column>
        <el-table-column prop="ExamResult" label="考试结果" width sortable>
        </el-table-column>
        <el-table-column min-width="80" prop="ExamTime" label="考试时间" width sortable>
        </el-table-column>
        <el-table-column label="操作">
          <template scope="scope">
            <el-link type="primary" @click="handleMemberAnswerOpen(scope.row.MemberExamId)">
              答题详情
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="MemberExam_close">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="MemberAnswerVisible" v-model="MemberAnswerVisible"
      :before-close="MemberAnswer_close" :close-on-click-modal="false">
      <el-table :data="MemberAnswerDataList" highlight-current-row v-loading="listLoading" style="width: 100%">
        <el-table-column prop="AccountShortName" label="客户名称" width sortable>
        </el-table-column>
        <el-table-column prop="StoreName" label="门店名称" width sortable>
        </el-table-column>
        <el-table-column prop="MemberName" label="学员名称" width sortable>
        </el-table-column>
        <el-table-column prop="TopicName" label="题目" width sortable>
        </el-table-column>
        <el-table-column prop="IsRightAnswer" label="正确答案" width sortable>
        </el-table-column>
        <el-table-column prop="MemberAnswer" label="学员答案" width sortable>
        </el-table-column>
        <!-- <el-table-column
            prop="IsRight"
            label="是否正确"
            width
            :formatter="formatIsRight"
            sortable>
          </el-table-column> -->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="MemberAnswer_close">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template>


<script>
import util from "../../../util/date";
import {
  ExaminationList,
  ExaminationPost,
  ExaminationPut,
  ExaminationGet,
  CertificateId_GetList,
  CurriculumId_GetList,
  ClearTipic_Delete,
  QrCodeExaminationGet,
  getExamTagListPage,
  GetTopicList,
  GetMemberExamList,
  GetMemberAnswerList,
  ExportToExcelMemberExamList,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      tags: [],
      fileList: [],
      Certificate_List: [],
      Curriculum_ist: [],
      token: {},
      DETAIS_IF: true,
      READ: true,
      READ_IF: true,
      UPLoad_IF: true,
      UPLoad_IF_Show: false,
      isShowHide: false,
      examId: 0,
      dialog_title: "",
      editLoading: false,
      editForm: {
        // ClassDate: "",
        // ClassStartTimeKey: "",
      },
      editFormRules: {
        Name: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        ExamType: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        CurriculumId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        Status: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        PassScore: [
          { required: true, message: "请选择", trigger: "blur" },
        ]
      },
      editFormVisible: false,
      editFormVisible_class: false,
      editFormVisible_jl: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      PL_IF: true,
      filters: {
        key: "",
        date: "",
      },
      MemberExamFilters: {
        AccountShortName: "",
        StoreName: "",
        MemberName: "",
      },
      users: [],
      users_dialog: [],
      users_dialog_jl: [],
      total: 0,
      total_dialog: 0,
      page: 1,
      page_dialog: 1,
      page_dialog_jl: 1,
      detailFormVisible: false,
      detailForm: {
      },
      QrCode_imageUrl: "",
      ErrorTipicVisible: false,
      ErrorTipicDataList: [],
      MemberExamVisible: false,
      MemberExamDataList: [],
      MemberAnswerVisible: false,
      MemberAnswerDataList: [],
      ExamId: 0,
      listLoading: false,
      sels: [], //列表选中列
      TencentMeetingNumber_if: false,
    };
  },
  methods: {
    async ExportMemberExamList(ids) {
      const { data } = await ExportToExcelMemberExamList({
        examId: ids,
      });
      if (data.success) {
        window.open("https://share.51i.cc" + data.msg);
        // window.location.href ="https://share.51i.cc" + data.msg;
      }
      else {
        this.$message({
          message: data.msg,
          type: "error",
        });
      }
    },
    handleAvatarSuccess(res, file) {
      if (file.response.success) {
      } else {
        this.$message({
          message: file.response.msg,
          type: "error",
        });
      }
    },
    link_class() {
      this.ExaminationList();
      this.page_dialog = 1;
      this.editFormVisible_class = true;
    },
    selsChange: function (value) {
      this.sels = value;
    },
    async TagsGet() {
      getExamTagListPage().then((res) => {
        this.tags = res.data.response;
      });
    },
    async editSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data;
          if (this.dialog_title == "新增") {
            data = await ExaminationPost(this.editForm);
          } else {
            data = await ExaminationPut(this.editForm);
          }
          if (data.data.success) {
            this.editFormVisible = false;
            this.$message({
              message: data.data.msg,
              type: "success",
            });
            this.getModules_search();
            this.editForm = {};
          }
          else {
            this.editFormVisible = false;
            this.$message({
              message: data.data.msg,
              type: "error",
            });
            this.getModules_search();
            this.editForm = {};
          }
        } else {
          return false;
        }
      });
    },
    handleAdd() {
      this.CertificateId_GetList_fn();
      this.CurriculumId_GetList_fn();
      this.TagsGet();
      this.editFormVisible = true;
      this.dialog_title = "新增";
      this.DETAIS_IF = false;
      this.examId = 0;
    },
    editForm_close() {
      this.editFormVisible = false;
      this.editForm = {};
    },
    detailForm_close() {
      this.detailFormVisible = false;
      this.detailForm = {};
    },
    ErrorTipic_close() {
      this.ErrorTipicVisible = false;
    },
    MemberAnswer_close() {
      this.MemberAnswerVisible = false;
    },
    // 答题详情
    async handleMemberAnswerOpen(ids) {
      await this.MemberAnswer_GetMemberAnswerList(ids);
      this.MemberAnswerVisible = true;
      this.dialog_title = "答题详情";
    },
    async MemberAnswer_GetMemberAnswerList(ids) {
      const { data } = await GetMemberAnswerList({
        memberExamId: ids,
      });
      this.MemberAnswerDataList = data.response;
    },
    MemberExam_close() {
      this.MemberExamVisible = false;
    },
    // 考试名单
    async handleMemberExamOpen(ids) {
      this.ExamId = ids;
      await this.MemberExam_GetMemberExamList(ids);
      this.MemberExamVisible = true;
      this.dialog_title = "考试名单";
    },
    async MemberExam_GetMemberExamList(ids) {
      let para = this.MemberExamFilters;
      para.ExamId = this.ExamId;
      await GetMemberExamList(para).then((res) => {
        this.MemberExamDataList = res.data.response;
      });
    },
    // 错题分析
    async handleErrorTipicOpen(ids) {
      await this.ErrorTipic_GetTopicList(ids);
      this.ErrorTipicVisible = true;
      this.dialog_title = "错题分析";
    },
    async ErrorTipic_GetTopicList(ids) {
      const { data } = await GetTopicList({
        ExamId: ids,
      });
      this.ErrorTipicDataList = data.response;
    },
    async details_ExaminationGet(ids) {
      const { data } = await ExaminationGet({
        id: ids,
      });
      this.editForm = data.response;
    },
    async QrCodeDetails_ExaminationGet(ids) {
      const { data } = await QrCodeExaminationGet({
        id: ids,
      });
      this.detailForm = data.response;
      if (data.response.QRCodeUrl) {
        this.QrCode_imageUrl = data.response.QRCodeUrl;
      }
    },
    // 查看二维码
    async handleDetailOpen(ids) {
      this.examId = ids;
      this.QrCodeDetails_ExaminationGet(ids);
      this.DETAIS_IF = true;
      this.detailFormVisible = true;
      this.dialog_title = "签到码";
    },
    // 查看
    async handleOpen(ids) {
      this.examId = ids;
      await this.CertificateId_GetList_fn();
      await this.CurriculumId_GetList_fn();
      this.details_ExaminationGet(ids);
      await this.TagsGet();
      this.DETAIS_IF = true;
      this.READ = true;
      this.READ_IF = true;
      this.editFormVisible = true;
      this.dialog_title = "查看";
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
    },
    async handleEdit(ids) {
      this.examId = ids;
      await this.CertificateId_GetList_fn();
      await this.CurriculumId_GetList_fn();
      this.details_ExaminationGet(ids);
      await this.TagsGet();
      this.editFormVisible = true;
      this.dialog_title = "编辑";
      this.DETAIS_IF = false;
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
      //此处根据选中行，判断是否符合导入
      let row = this.currentRow;
    },
    callFunc(item) {
      this[item.Func].apply(this, item);
    },
    CertificateId_change(e) {
      this.CertificateId_GetList_fn(e);
    },
    async CertificateId_GetList_fn(e) {
      const { data } = await CertificateId_GetList({
        name: e,
      });
      this.Certificate_List = data.response;
    },
    CurriculumId_change(e) {
      this.CurriculumId_GetList_fn(e);
    },
    async CurriculumId_GetList_fn(e) {
      if (this.dialog_title == "新增") {
        const { data } = await CurriculumId_GetList({
          name: e,
          examId: 0
        });
        this.Curriculum_ist = data.response;
      }
      else {
        const { data } = await CurriculumId_GetList({
          name: e,
          examId: this.examId
        });
        this.Curriculum_ist = data.response;
      }
    },
    CurriculumId_change_upt_ExamType(e) {
      this.Curriculum_ist.find((item) => {
        //model就是上面的数据源
        if (item.Key === e) {
          if (item.Type == 0) {
            this.$set(this.editForm, "ExamType", "线上考试");
          }
          else {
            this.$set(this.editForm, "ExamType", "线下考试");
          }
        }
      });
    },
    formatIsRight: function (row, column) {
      let data = row[column.property]
      if (data) {
        return "正确"
      } else {
        return "错误"
      }
    },
    //日期显示转换
    formatDateTime: function (row, column) {
      let data = row[column.property]
      if (data == null) {
        return null
      } else {
        return util.formatDate.format(new Date(data), "yyyy-MM-dd");
      }
    },
    formatStatus: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return "正常"
      } else if (data == 0) {
        return "禁用";
      } else {
        return null
      }
    },
    formatType: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return "线下培训"
      } else if (data == 0) {
        return "线上培训";
      } else {
        return null
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    getModules_search() {
      this.page = 1;
      this.getModules();
    },
    ImportUserTagDetail() {
      this.page = 1;
      this.getModules();
    },
    // handleChange(file)
    // {
    //   //验证文件格式
    //   const isXlS =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    //     file.type === "application/vnd.ms-excel";
    //   if (!isXlS) {
    //     this.$message.error("Please upload files in xls and xlsx formats!");
    //     return;
    //   }
    // },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
    },
    handonerror() {
      // console.log("超时失败");
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
      this.$message({
        message: "您的上传已超时，请再次尝试",
        type: "error",
      });
      loading.close();
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
      if (file.success == true) {
        loading.close();
        this.QUEST_IF = true;
        this.$alert(file.msg, "提示", {
          confirmButtonText: "确定",
        });
        this.getModules_search();
      } else if (file.success == false) {
        loading.close();
        this.$alert(file.msg, "提示", {
          confirmButtonText: "确定",
        });
      } else {
        loading.close();
        this.$message({
          message: "您的上传已超时，请再次尝试",
          type: "error",
        });
      }
    },
    //获取用户列表
    getModules() {
      let para = this.filters;
      para.page = this.page;
      this.listLoading = true;
      ExaminationList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        // console.log(res.data.response.data)
        // this.buttonList.forEach(element => {
        //   if(element.Func == 'setCouponSystemPush')
        //   {
        //      this.isShowHide = true;
        //   }
        // });
      });
    },
    //删除
    handleDel(ids) {
      // console.log(ids);
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          // let para = { id: ids };
          ClassScheduleDelete({
            id: ids,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => { });
    },
    //清除题目
    handleClearTipic(ids) {
      this.$confirm("确认清除题目吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          ClearTipic_Delete({
            id: ids,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "清除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => { });
    },
    //审核,阻止，驳回保存
    saveMemberSaveAudit(id, status) {
      var msg = '';
      if (status == -1) {
        msg = "确认驳回吗?"
      } else if (status == 1) {
        msg = "确认通过审核吗?"
      } else if (status == 2) {
        msg = "确认阻止吗?"
      }
      this.$confirm(msg, "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          MemberSaveAudit({
            id: id,
            status: status
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => { });
    },

  },
  mounted() {
    // let roleNames = JSON.parse(localStorage.getItem("roleNames"));
    this.getModules();
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: "Bearer " + tokenStr,
    };
    console.log(this.token);
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.leftCell {
  text-align: left !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
<style>
.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

/* 
  .el-link.el-link--primary:hover {
    color: #409eff !important;
  } */

.el-link.el-link {
  color: #409eff !important;
}

.el-link.is-underline:hover:after {
  border-bottom: 1px solid #409eff !important;
}

.el-link.el-link--default:after,
.el-link.el-link--primary.is-underline:hover:after,
.el-link.el-link--primary:after {
  border-color: #409eff !important;
}

.el-pager li.active {
  color: #409eff !important;
}
</style>
